<template>
  <ul
    class="StatRow"
    data-theme="light"
  >
    <slot />
  </ul>
</template>

<script lang="ts" setup>
</script>

<style lang="scss" scoped>
.StatRow {
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  grid-auto-flow: column;

  border-bottom: solid 1px var(--themeColorNeutral100);
  background-color: var(--themeColorWhite);
}
</style>
